import { render, staticRenderFns } from "./usage-type.vue?vue&type=template&id=713f721a&scoped=true&lang=html&"
import script from "./usage-type.vue?vue&type=script&lang=js&"
export * from "./usage-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713f721a",
  null
  
)

export default component.exports